import React, {useEffect, useState} from "react";
import {ComponentHeader, FilterContainer, FilterItem, MainContainer, SearchContainer} from "./styles";
import Button from "../../common/atoms/button";
import AddSubscriptionPlanModal from "../../components/AddSubscriptionPlanModal";
import TableComponent from "../../common/components/TableComponent";
import Utility from "../../utility";
import subscriptionPlans from "../../services/subscriptionPlans";
import ConfirmRejectSubscriptionModal from "../../components/ConfirmRejectSubscriptionModal";

const filterList = ["All", "Pending", "Confirmed", "Rejected", "Expired"];
const dateList = {
    All: {label: "Updated on", key: 'modifiedOn'},
    Pending: {label: "Created on", key: 'modifiedOn'},
    Confirmed: {label: "Confirmed on", key: 'confirmedOn'},
    Rejected: {label: "Rejected on", key: 'rejectedOn'},
    Expired: {label: "Expired on", key: 'expiresOn'},
}
const SubscriptionList = (props) => {
    const [isVisible, setVisible] = useState(false)
    const [actionModalVisible, setActionModalVisible] = useState(false)
    const [selectedUser, setSelectedUser] = useState(null)
    const [subscriptionList, setSubscriptionList] = useState([])
    const [filteredList, setFilteredList] = useState([])
    const [selectedFilter, setSelectedFilter] = useState("All");

    const fetchSubscriptionList = async () => {
        let [err, subscriptionPlanList] = await Utility.parseResponse(subscriptionPlans.getSubscriptionList());
        if (!subscriptionPlanList || err)
            return Utility.apiFailureToast("Unable to get subscriptions");
        subscriptionPlanList.sort((a, b) => new Date(b.modifiedOn).getTime() - new Date(a.modifiedOn).getTime());
        setSubscriptionList(subscriptionPlanList)
        setFilteredList(subscriptionPlanList)
    }

    useEffect(() => {
        fetchSubscriptionList().then(() => 'Fetched')
    }, [actionModalVisible])

    const onFilterClicked = (filterType) => {
        setSelectedFilter(filterType)
        let allList = [...subscriptionList]
        switch (filterType) {
            case "All":
                break;
            case "Pending":
                allList = allList.filter(data => data.status === "PENDING")
                break;
            case "Confirmed":
                allList = allList.filter(data => data.status === "CONFIRM")
                break;
            case "Rejected":
                allList = allList.filter(data => data.status === "REJECT")
                break;
            case "Expired":
                allList = allList.filter(data => data.status === "EXPIRED")
                break;
        }
        setFilteredList(allList);
    }

    return (
        <>
            <AddSubscriptionPlanModal isVisible={isVisible} setVisible={setVisible}
                                      refreshPlans={fetchSubscriptionList}/>
            <ConfirmRejectSubscriptionModal isVisible={actionModalVisible} setVisible={setActionModalVisible}
                                            selectedUser={selectedUser}/>
            <MainContainer>
                <ComponentHeader>
                    <SearchContainer>
                        Subscription List ({filteredList?.length})
                    </SearchContainer>
                    {/*<Button width='fit-content' onClick={() => setVisible(true)}>+ Add Plan</Button>*/}
                    <FilterContainer>
                        {filterList.map(filter => <FilterItem isSelected={selectedFilter === filter}
                                                              onClick={() => onFilterClicked(filter)}>{filter?.toUpperCase()}</FilterItem>)}
                    </FilterContainer>
                </ComponentHeader>
                <TableComponent.Table cellpadding="0" cellspacing="0">
                    <TableComponent.TableHead>
                        <TableComponent.HeadColumn>User</TableComponent.HeadColumn>
                        <TableComponent.HeadColumn>Phone</TableComponent.HeadColumn>
                        <TableComponent.HeadColumn>Plan</TableComponent.HeadColumn>
                        <TableComponent.HeadColumn>Plan Days</TableComponent.HeadColumn>
                        <TableComponent.HeadColumn>Amount</TableComponent.HeadColumn>
                        <TableComponent.HeadColumn>Status</TableComponent.HeadColumn>
                        <TableComponent.HeadColumn>{`${dateList[selectedFilter]?.label}`}</TableComponent.HeadColumn>
                        {selectedFilter === "Confirmed" &&
                            <TableComponent.HeadColumn>Expires on</TableComponent.HeadColumn>}
                    </TableComponent.TableHead>
                    <TableComponent.TableBody>
                        {filteredList?.map((item) => (
                            <TableComponent.BodyRow key={item._id}>
                                <TableComponent.BodyColumn>{item.user?.name}</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>{item.user?.phone}</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>{item.plan?.name}</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>{item.plan?.noOfDays > 0 ? item.plan?.noOfDays : 'Lifetime'}</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>{item.plan?.price <= 0 ? 'Free' : `₹${item.plan?.price}`}</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>{item.status}</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>{new Date(item[dateList[selectedFilter]?.key]).toDateString()}</TableComponent.BodyColumn>
                                {selectedFilter === "Confirmed" &&
                                    <TableComponent.BodyColumn>{item.expiresOn === 0 ? '-' : new Date(item.expiresOn).toDateString()}</TableComponent.BodyColumn>}
                                {selectedFilter === "All" || selectedFilter === "Pending" ? <TableComponent.BodyColumn>
                                    {item.status === 'PENDING' && <Button type="outline" onClick={() => {
                                        setSelectedUser(item)
                                        setActionModalVisible(true)
                                    }}>Confirm /
                                        Reject</Button>}
                                </TableComponent.BodyColumn> : null}
                            </TableComponent.BodyRow>
                        ))}
                    </TableComponent.TableBody>
                </TableComponent.Table>

            </MainContainer>
        </>
    )
}
export default SubscriptionList;
